<template>
  <div>
    <div>
      <el-form :inline="true">
        <!--  <el-form-item label="阶段">
                    <el-select v-model="stageValue" placeholder="请选择">
                        <el-option v-for="item in stage" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
        </el-form-item>-->
        <el-form-item label="标签">
          <el-select
            style="margin-left: 10px;width: 300px;"
            v-model="gradesValue"
            placeholder="请选择"
          >
            <el-option v-for="item in grades" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="天数">
                <el-select style="margin-left: 10px;" v-model.number="anyDay" placeholder="请选择" width="500">
                    <el-option v-for="item in anyDays" :key="item" :label="item" :value="item">
                    </el-option>
                </el-select>
        </el-form-item>-->
        <!--  <el-form-item label="阶段">
                    <el-select style="margin-left: 10px;" v-model="gradeClassify" placeholder="请选择" width="500">
                        <el-option v-for="item in gradeClassifies" :key="item" :label="item" :value="item">
                        </el-option>
                    </el-select>
        </el-form-item>-->
        <el-form-item label="题型">
          <el-select
            style="margin-left: 10px;width:200px;"
            v-model="questionTypesValue"
            placeholder="请选择"
          >
            <el-option
              v-for="item in questionTypes"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button style="margin-left: 10px;" type="primary" @click="fetchData()">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button style="margin-left: 10px;" type="primary" @click="fetcherror()">查询录错题</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="questions" style="width: 100%;margin-top: 50px;">
      <!--  <el-table-column type="index" width="80">
      </el-table-column>-->
      <el-table-column prop="grade" label="标签" width="150"></el-table-column>
      <el-table-column prop="questionTypeStr" label="题型" width="150"></el-table-column>
      <el-table-column label="题干">
        <el-table-column property="intro" label="文本" width="200"></el-table-column>
        <el-table-column property="image" label="图片" width="100">
          <template slot-scope="scope">
            <img
              v-if="scope.row.image"
              style="width: 50px;height:50px;"
              :src=" scope.row.image.url"
            />
          </template>
        </el-table-column>
        <el-table-column property="voice" label="语音" width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            <a :href="scope.row.voice" target="_blank" class="buttonText">{{scope.row.voice}}</a>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <!-- <el-button size="mini" type="success" @click="handleSave(scope.$index, scope.row)">保存排序</el-button> -->
          <!-- <el-button size="mini" @click="handleCopy(scope.$index, scope.row)">复用</el-button> -->

          <el-button size="mini" type="success" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block" style="float: right;margin:30px;">
      <el-pagination
        :current-page="questionCurrentPage"
        :page-size="pageSize"
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :total="counts"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import AV from "leancloud-storage";

import Question from "../../model/question";
import Grade from "../../model/grade";
import QuestionType from "../../model/questionType";

export default {
  data() {
    return {
      pageSize: 15,
      questionCurrentPage: 1,
      questionTypes: [],
      grades: [],
      stage: [
        {
          value: "all",
          label: "全部",
        },
        {
          value: "initiation",
          label: "启蒙课程",
        },
        {
          value: "1",
          label: "基础课程",
        },
        {
          value: "2",
          label: "进阶课程",
        },
        {
          value: "3",
          label: "提高课程",
        },
      ],
      stageValue: "all",
      questionTypesValue: "",
      gradesValue: "",

      gradeClassifies: ["initiation", "1", "2", "3"],

      gradeClassify: "initiation",
      anyDay: "全部",
      indexInOneDay: "全部",
      anyDays: [],
      indexInOneDays: [],

      questions: [],
      questionsAV: [],
      counts: 0,
    };
  },

  created() {
    this.getData();
    // this.fetchData();
  },

  methods: {
    formatClassify(str) {
      switch (str) {
        case "initiation":
          return "启蒙课程";
        case "1":
          return "基础课程";
        case "2":
          return "进阶课程";
        case "3":
          return "提高课程";
      }
    },
    getData() {
      // this.anyDays.push('全部')
      // this.indexInOneDays.push('全部')
      // for (let i = 0; i < 100; i++) {
      //     this.anyDays.push(i + 1)
      //     this.indexInOneDays.push(i + 1)
      // }

      // if (localStorage.anyDay) {
      //     this.anyDay = localStorage.anyDay
      // }

      // if (localStorage.indexInOneDay) {
      //     this.indexInOneDay = localStorage.indexInOneDay
      // }

      // this.fetchData()
      new AV.Query(QuestionType)
        .descending("createdAt")
        .find()
        .then((questionTypes) => {
          this.questionTypes = questionTypes;
          this.questionTypesAV = questionTypes;

          this.questionTypes.unshift({
            id: "",
            name: "全部",
          });

          if (localStorage.questionTypesValue) {
            this.questionTypesValue = localStorage.questionTypesValue;
          }
        });
      let that = this;
      new AV.Query(Grade)
        .ascending("createdAt")
        .find()
        .then((grades) => {
          this.gradesAV = grades;
          // this.grades = grades;

          this.grades.push({
            id: "",
            name: "全部",
          });
          for (let i = 0; i < grades.length; i++) {
            //   console.log(grades[i].index)
            this.grades.push({
              id: grades[i].id,
              name: grades[i].grade,
              // name:
              //   grades[i].series +
              //   " - " +
              //   grades[i].name +
              //   " - " +
              //   grades[i].classify
            });
          }

          // if (localStorage.gradesValue) {
          //     this.gradesValue = localStorage.gradesValue
          // }
        });
    },
    fetchData(pageTemp) {
      console.log(pageTemp);
      this.queryType = 1;
      if (pageTemp == 1) {
        this.questionCurrentPage = pageTemp;
      }
      let query = new AV.Query(Question)
        .include("grade")
        .include("questionType")
        .limit(this.pageSize)
        .skip((this.questionCurrentPage - 1) * this.pageSize);

      if (this.questionTypesValue.length > 0) {
        for (let i = 0; i < this.questionTypesAV.length; i++) {
          if (this.questionTypesValue == this.questionTypesAV[i].id) {
            query.equalTo("questionType", this.questionTypesAV[i]);
          }
        }
      }

      if (this.gradesValue.length > 0) {
        //  console.log(this.gradesValue );
        for (let i = 0; i < this.gradesAV.length; i++) {
          if (this.gradesValue == this.gradesAV[i].id) {
            // console.log(111);
            query.equalTo("grade", this.gradesAV[i]);
          }
        }
      }

      query.count().then((c) => {
        this.counts = c;
      });
      query
        .descending("series")
        // .addDescending('updatedAt')
        // .addDescending('indexInOneDay')

        .find()
        .then((questions) => {
          this.questionsAV = questions;
          console.log(this.questionsAV);
          //   console.log(questions)
          // console.log(questions.length);

          // this.questions = questions;
          this.questions = [];
          // questions.sort(function(a,b){
          //   return a.indexInOneDay-b.indexInOneDay
          // })
          console.log(questions);
          // questions[i].grade.series + " - " + questions[i].grade.name,
          for (let i = 0; i < questions.length; i++) {
            // console.log(questions[i]);
            console.log(questions[i].questionData, i);
            this.questions.push({
              id: questions[i].id,
              grade: questions[i].grade.grade,
              indexInOneDay: questions[i].indexInOneDay,
              questionTypeStr: questions[i].questionType.name,
              intro: questions[i].questionData[0][0].intro,
              image: questions[i].questionData[0][0].image,
              voice: questions[i].questionData[0][0].voice.url,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    fetcherror() {
      new AV.Query(Question)
        .include("questionType")
        .include("grade")
        .limit(1000)
        .find()
        .then((NJQuestion) => {
          console.log(NJQuestion);
          new AV.Query(Question)
            .include("questionType")
            .include("grade")
            .limit(1000)
            .skip(1000)
            .find()
            .then((NJQuestion2) => {
              console.log(NJQuestion2);

              let jijihehe = NJQuestion2.concat(NJQuestion);
              let txt = [];
              let gdfs = [];
              let q = [];
              for (let i in jijihehe) {
                if (jijihehe[i].questionType.series == 1) {
                  if (jijihehe[i].questionData[1].length != 3) {
                  }
                } else if (jijihehe[i].questionType.series == 2) {
                  if (
                    jijihehe[i].questionData[1].length != 3 ||
                    !jijihehe[i].questionData[1][0].voice
                  ) {
                    txt.push(jijihehe[i]);
                  }
                } else if (
                  jijihehe[i].questionType.series == 3 ||
                  jijihehe[i].questionType.series == 4
                ) {
                  if (!jijihehe[i].questionData[0][0].intro) {
                    gdfs.push(jijihehe[i]);
                  }
                } else if (jijihehe[i].questionType.series == 5) {
                  if (jijihehe[i].questionData[1].length != 0) {
                    if (!jijihehe[i].questionData[1][0].voice) {
                      q.push(jijihehe[i]);
                    }
                  } else {
                    q.push(jijihehe[i]);
                  }
                }
              }

              this.questions = [];
              let jihe = q.concat(gdfs).concat(txt);
              jihe = jihe.reverse();
              for (let i = 0; i < jihe.length; i++) {
                // console.log(questions[i]);
                // console.log(jihe[i].questionData, i);
                this.questions.push({
                  id: jihe[i].id,
                  grade: jihe[i].grade.grade,
                  indexInOneDay: jihe[i].indexInOneDay,
                  questionTypeStr: jihe[i].questionType.name,
                  intro: jihe[i].questionData[0][0].intro,
                  image: jihe[i].questionData[0][0].image,
                  voice: jihe[i].questionData[0][0].voice.url,
                });
              }
            });
        });

      // new AV.Query(Question)
      // .include("questionType")
      // .include("grade")
      // .limit(1000)
      // .skip(1000)
      // .find()
      // .then((NJQuestion) => {
      //   console.log(NJQuestion)
      //   let txt2 = [];
      //   let gdfs2 = [];
      //   let q2 = [];
      //   for (let i in NJQuestion) {
      //     if (NJQuestion[i].questionType.series == 1) {
      //       if (NJQuestion[i].questionData[1].length != 3) {
      //       }
      //     } else if (NJQuestion[i].questionType.series == 2) {
      //       if (
      //         NJQuestion[i].questionData[1].length != 3 ||
      //         !NJQuestion[i].questionData[1][0].voice
      //       ) {
      //         txt2.push(NJQuestion[i]);
      //       }
      //     } else if (
      //       NJQuestion[i].questionType.series == 3 ||
      //       NJQuestion[i].questionType.series == 4
      //     ) {
      //       if (!NJQuestion[i].questionData[0][0].intro) {
      //         gdfs2.push(NJQuestion[i]);
      //       }
      //     } else if (NJQuestion[i].questionType.series == 5) {
      //       if (NJQuestion[i].questionData[1].length != 0) {
      //         if (!NJQuestion[i].questionData[1][0].voice) {
      //           q2.push(NJQuestion[i]);
      //         }
      //       } else {
      //         q2.push(NJQuestion[i]);
      //       }
      //     }
      //   }

      //   let qqs = []
      //   let jihe2 = q2.concat(gdfs2).concat(txt2);
      //   jihe2 = jihe2.reverse()
      //   for (let i = 0; i < jihe2.length; i++) {
      //     // console.log(questions[i]);
      //     // console.log(jihe2[i].questionData, i);
      //     qqs.push({
      //       id: jihe2[i].id,
      //       grade: jihe2[i].grade.grade,
      //       indexInOneDay: jihe2[i].indexInOneDay,
      //       questionTypeStr: jihe2[i].questionType.name,
      //       intro: jihe2[i].questionData[0][0].intro,
      //       image: jihe2[i].questionData[0][0].image,
      //       voice: jihe2[i].questionData[0][0].voice.url,
      //     });
      //   }
      //   this.questions = this.questions.concat(qqs)
      //   console.log(this.questions)
      //   console.log(qqs)
      // })
    },

    handleCurrentChange(page) {
      this.questionCurrentPage = page;
      if (this.queryType == 1) {
        this.fetchData();
      } else {
        this.fetchData2();
      }
    },

    handleEdit(index, row) {
      this.$router.push({
        path: "/question/add",
        query: {
          id: row.id,
        },
      });
    },
    handleSave(index, row) {
      let question = this.questionsAV[index];

      question.indexInOneDay = row.indexInOneDay;

      question.save();
    },
    handleCopy(index, row) {
      this.$router.push({
        path: "/question/add",
        query: {
          id: row.id,
          copy: "1",
        },
      });
    },
    handleDelete(index, row) {
      AV.User.current()
        .fetch({
          keys: "role",
        })
        .then((r) => {
          if (r.get("role") == "1999") {
            this.$confirm("此操作将永久删除等级, 是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });

                this.questionsAV[index]
                  .destroy()
                  .then(() => {
                    this.questions.splice(index, 1);
                    this.questionsAV.splice(index, 1);
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              })
              .catch(() => {});
          } else {
            this.$message({
              type: "warning",
              message: "没有权限!",
            });
          }
        });
    },
  },
};
</script>
